// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1yOLQ","form":"styles_form__1mE07"};